<div class="w-full max-w-3xl">
    <div class="grid sm:grid-cols-3 gap-6 w-full mt-8">
        <ng-container>
            <!-- Summary -->
            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                <div class="flex items-start justify-between">
                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Comprados</div>
                </div>
                <div class="flex flex-col items-center mt-2">
                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-blue-500">
                        {{ resumen.folios }}</div>
                    <div class="text-lg font-medium text-blue-600 dark:text-blue-500">Folios</div>
                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                        <!-- <div class="text-md font-medium truncate">Completed:</div> -->
                        <!-- <div class="ml-1.5 text-lg font-semibold">13</div> -->
                    </div>
                </div>
            </div>
            <!-- Overdue -->
            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                <div class="flex items-start justify-between">
                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Usados</div>
                </div>
                <div class="flex flex-col items-center mt-2">
                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-red-500">
                        {{ resumen.usados }}</div>
                    <div class="text-lg font-medium text-red-600 dark:text-red-500">
                        <ng-container *ngIf="resumen.vencidos == 0">
                            Folios
                        </ng-container>

                        <ng-container *ngIf="resumen.vencidos != 0">
                            {{ resumen.vencidos }} Vencidos
                        </ng-container>
                    </div>
                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                        <!-- <div class="text-md font-medium truncate">From yesterday:</div>
                    <div class="ml-1.5 text-lg font-semibold">9</div> -->
                    </div>
                </div>
            </div>

            <!-- Issues -->
            <div class="flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
                <div class="flex items-start justify-between">
                    <div class="text-lg font-medium tracking-tight leading-6 truncate">Disponibles</div>
                </div>
                <div class="flex flex-col items-center mt-2">
                    <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-amber-500">
                        {{ resumen.disponibles }}</div>
                    <div class="text-lg font-medium text-amber-600 dark:text-amber-500">Folios</div>
                    <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                        <!-- <div class="text-md font-medium truncate">Closed today:</div>
                    <div class="ml-1.5 text-lg font-semibold">19</div> -->
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <div class="mt-12 mb-10 border-t"></div>
</div>

<!-- Budget details -->
<div class="sm:col-span-2 md:col-span-4 flex flex-col flex-auto p-6 bg-card shadow rounded-2xl overflow-hidden">
    <div class="flex flex-col sm:flex-row items-start justify-between">
        <div class="text-lg font-medium tracking-tight leading-6 truncate">Paquetes adquiridos</div>
        <div class="mt-3 sm:mt-0 sm:ml-2">
            <!-- <mat-button-toggle-group value="this-week" #githubIssuesWeekSelector="matButtonToggleGroup"> -->
                <button (click)="buyFolios()" class="ml-4" mat-flat-button type="button" [color]="'primary'">
                    <mat-icon svgIcon="heroicons_solid:shopping-cart"></mat-icon> Comprar folios
                </button>
            <!-- </mat-button-toggle-group> -->
        </div>
    </div>
    <div class="flex flex-col flex-auto mt-2 overflow-x-auto">
        <app-grid-component
            *ngIf="verGrid"
            [datos]="objetoGridConfiguration?.Data"
            [columns]="objetoGridConfiguration.Columns"
            [exportExcel]="objetoGridConfiguration.ExportExcel"
            [columnHiding]="objetoGridConfiguration.ColumnHiding"
            [Checkbox]="objetoGridConfiguration.Checkbox"
            [Editing]="objetoGridConfiguration.Editing"
            [Columnchooser]="objetoGridConfiguration.Columnchooser"
            [searchPanel]="objetoGridConfiguration.SearchPanel"
            [scroll]="objetoGridConfiguration.Scroll"
            (messageEvent)="receiveMessage($event)"
            (datosevent)="datosMessage($event)"
            [toolbar]="objetoGridConfiguration.ToolBox"
            (onRowUpdated)="Actualizar($event)"
            (modificar)='modificar($event.modificar.key)'
            (eliminar)='eliminar($event.eliminar.key)'
            [descargarExcel]="descargarExcel" 
            [nombreReporte]="nombreReporte"
        ></app-grid-component>

        <!-- <div *ngIf="data?.rows.length === 0">
            <div class="alert alert-primary" role="alert">
                <small>Aún no hay registros</small>
            </div>
        </div> -->
    </div>
</div>